// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nm-0";